import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import QueEsEOS from "@/pages/QueEsEOS";
import PreguntasFrecuentes from "@/pages/PreguntasFrecuentes";
import EOSChile from "@/pages/EOSChile";
import Implementacion from "@/pages/Implementacion";
import EficienciaOperativa from "@/pages/EficienciaOperativa";
import EOSvsOKR from "@/pages/EOSvsOKR";
import EOSParaPymes from "@/pages/EOSParaPymes";
import EOSEmpresasFamiliares from "@/pages/EOSEmpresasFamiliares";
import EOSEmpresasTecnologia from "@/pages/EOSEmpresasTecnologia";
import EOSPeru from "@/pages/EOSPeru";
import EOSColombia from "@/pages/EOSColombia";
import EOSArgentina from "@/pages/EOSArgentina";
import EOSUruguay from "@/pages/EOSUruguay";
import EOSEcuador from "@/pages/EOSEcuador";
import EOSParaguay from "@/pages/EOSParaguay";
import ElModeloEOS from "@/pages/ElModeloEOS";
import LibrosEOS from "@/pages/LibrosEOS";
import LibroTraccion from "@/pages/LibroTraccion";
import HistoriaEOS from "@/pages/HistoriaEOS";
import RompiendoElTecho from "@/pages/RompiendoElTecho";
import BlogPost from "@/pages/BlogPost";
import Testimonios from "@/pages/Testimonios";
import DoloresDelEmpresario from "@/pages/DoloresDelEmpresario";
import Contacto from "@/pages/Contacto";
import ContactoGracias from "@/pages/ContactoGracias";
import ImplementadorEOS from "@/pages/ImplementadorEOS";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/que-es-eos" element={<QueEsEOS />} />
          <Route path="/eos-en-chile" element={<EOSChile />} />
          <Route path="/implementacion" element={<Implementacion />} />
          <Route path="/eficiencia-operativa-empresas" element={<EficienciaOperativa />} />
          <Route path="/eos-vs-okr" element={<EOSvsOKR />} />
          <Route path="/eos-para-pymes" element={<EOSParaPymes />} />
          <Route path="/eos-empresas-familiares" element={<EOSEmpresasFamiliares />} />
          <Route path="/eos-empresas-tecnologia" element={<EOSEmpresasTecnologia />} />
          <Route path="/eos-peru" element={<EOSPeru />} />
          <Route path="/eos-colombia" element={<EOSColombia />} />
          <Route path="/eos-argentina" element={<EOSArgentina />} />
          <Route path="/eos-uruguay" element={<EOSUruguay />} />
          <Route path="/eos-ecuador" element={<EOSEcuador />} />
          <Route path="/eos-paraguay" element={<EOSParaguay />} />
          <Route path="/el-modelo-eos" element={<ElModeloEOS />} />
          <Route path="/libros-eos" element={<LibrosEOS />} />
          <Route path="/libro-traccion-gino-wickman" element={<LibroTraccion />} />
          <Route path="/historia-eos" element={<HistoriaEOS />} />
          <Route path="/rompiendo-el-techo" element={<RompiendoElTecho />} />
          <Route path="/testimonios-eos" element={<Testimonios />} />
          <Route path="/dolores-del-empresario" element={<DoloresDelEmpresario />} />
          <Route path="/faq" element={<PreguntasFrecuentes />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/contacto-gracias" element={<ContactoGracias />} />
          <Route path="/implementador-eos" element={<ImplementadorEOS />} />
          <Route path="/responsabilidad-sin-microgestion" element={<BlogPost />} />
          <Route path="/persona-correcta-puesto-correcto" element={<BlogPost />} />
          <Route path="/equipo-liderazgo-conversaciones-dificiles" element={<BlogPost />} />
          <Route path="/roles-responsabilidades-confusas-empresa" element={<BlogPost />} />
          <Route path="/empresa-dependiente-del-fundador" element={<BlogPost />} />
          <Route path="/problemas-escalan-al-dueno" element={<BlogPost />} />
          <Route path="/dejar-de-apagar-incendios-empresa" element={<BlogPost />} />
          <Route path="/reuniones-largas-sin-resultados" element={<BlogPost />} />
          <Route path="/ventas-crecen-utilidad-baja" element={<BlogPost />} />
          <Route path="/indicadores-semanales-negocio" element={<BlogPost />} />
          <Route path="/inteligencia-artificial-y-eos" element={<BlogPost />} />
          <Route path="/como-construir-un-tablero-de-indicadores" element={<BlogPost />} />
          <Route path="/herramientas-tecnologicas-para-gestionar-eos-ninety" element={<BlogPost />} />
          <Route path="/organizacion-correcta-antes-de-completar-el-equipo" element={<BlogPost />} />
          <Route path="/crecer-sin-que-tu-empresa-se-vuelva-mas-compleja" element={<BlogPost />} />
          <Route path="/contrataste-un-gerente-que-esperas-de-el" element={<BlogPost />} />
          <Route path="/persona-correcta-puesto-correcto-gwc-eos" element={<BlogPost />} />
          <Route path="/por-que-los-mismos-problemas-vuelven-en-tu-empresa" element={<BlogPost />} />
          <Route path="/delegar-sin-desaparecer-autonomia-equipo" element={<BlogPost />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
